import { c as _c } from "react/compiler-runtime";
import { Loader2, Paperclip } from 'lucide-react';
import { toast } from 'sonner';
import { useLocalization } from '@/app/(app)/_providers/localization/LocalizationProvider';
export function TempUploadPanel(t0) {
  const $ = _c(15);
  const {
    uploading,
    onSelectFile
  } = t0;
  const {
    messages
  } = useLocalization();
  let t1;
  if ($[0] !== messages || $[1] !== onSelectFile) {
    t1 = async file => {
      if (!file) {
        return;
      }
      if (!file.type.startsWith("image/") && !file.type.startsWith("application/pdf")) {
        toast.error(messages.upload.invalidType);
        return;
      }
      await onSelectFile(file);
    };
    $[0] = messages;
    $[1] = onSelectFile;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleFile = t1;
  let t2;
  if ($[3] !== handleFile) {
    t2 = <input id="chat-temp-upload-input" type="file" accept="image/*,.pdf" className="hidden" onChange={async event => {
      const file_0 = event.target.files?.[0] || null;
      await handleFile(file_0);
      event.target.value = "";
    }} />;
    $[3] = handleFile;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== handleFile) {
    t3 = async event_1 => {
      event_1.preventDefault();
      const file_1 = event_1.dataTransfer.files?.[0] || null;
      await handleFile(file_1);
    };
    $[5] = handleFile;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== uploading) {
    t4 = uploading ? <Loader2 className="h-4.5 w-4.5 animate-spin" /> : <Paperclip className="h-4.5 w-4.5" />;
    $[7] = uploading;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <button type="button" tabIndex={0} onClick={_temp} onKeyDown={_temp2} onDrop={t3} className="text-muted-foreground hover:text-foreground flex h-9 w-9 shrink-0 items-center justify-center rounded-full transition-colors">{t4}</button>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t2 || $[13] !== t5) {
    t6 = <>{t2}{t5}</>;
    $[12] = t2;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
function _temp2(event_0) {
  if (event_0.key === "Enter") {
    document.getElementById("chat-temp-upload-input")?.click();
  }
}
function _temp() {
  return document.getElementById("chat-temp-upload-input")?.click();
}